import React, { useEffect, useState } from "react";
import { Button, Input, Select, Table } from "antd";
import "aos/dist/aos.css";
import "../../MainCSS.css";
import { Option } from "antd/es/mentions";
import axios from "axios";
import { toast } from "react-toastify";
import { GetSupplierMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';
import { SaveSupplierMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';
import { UpdateSupplierMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';
import { DeleteSupplierMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';

const SupplierMaster = () => {

const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };

const commonHeaders1 = {
  headers: {
    createdBy: userId,
    updatedBy: userId,
  },
}

  const [errors, setErrors] = useState({
    supplierName: "",
    address: "",
    city: "",
    pinCode: "",
    state: "",
    code: "",
    gstIn: "",
    contactPerson1: "",
    designation1: "",
    mobileNo1: "",
    emailId1: "",
    contactPerson2: "",
    designation2: "",
    mobileNo2: "",
    itemSupplied: "",
    bankName: "",
    bankAccNumber: "",
    branch: "",
    ifscCode: "",
    paymentCreditPeriod: "",
    panNumber: "",
  });


  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const [supplierId, setSupplierId] = useState("");
  const [supplierName, setSupplierName] = useState(""); 
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [state, setState] = useState("");
  const [code, setCode] = useState("");
  const [gstIn, setGstIn] = useState("");
  const [contactPerson1, setContactPerson1] = useState("");
  const [designation1, setDesignation1] = useState("");
  const [mobileNo1, setMobileNo1] = useState("");
  const [emailId1, setEmailId1] = useState("");
  const [contactPerson2, setContactPerson2] = useState("");
  const [designation2, setDesignation2] = useState("");
  const [mobileNo2, setMobileNo2] = useState("");
  const [itemSupplied, setItemSupplied] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankAccNumber, setBankAccNumber] = useState("");
  const [branch, setBranch] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [paymentCreditPeriod, setPaymentCreditPeriod] = useState("");
  const [panNumber, setPanNumber] = useState("");

  const [allSupplier, setAllSupplier] = useState([]);
  const [updateButton, setUpdateButton] = useState(false);
  const [saveButton, setSaveButton] = useState(true);

  // const [showForm, setShowForm] = useState(false)
  // const [showTable, setShowTable] = useState(true)
  
  // const handleShowForm = () => {
  //   setShowTable(false)
  //   setShowForm(true)
  // }


  //======Search data from table===============

  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allSupplier.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };


    // Fetch Supplier Names
    let isSupplierFetched = false;
    useEffect(() => {
      if (isSupplierFetched) return;
      fetchSupplier();
      isSupplierFetched = true;
    }, []);

  // ==============Get Table Data================

  let isError = false;

  const fetchSupplier = async () => {

    try {
      const response = await axios.get(GetSupplierMaster,commonHeaders1);
      if (response.data !== null) {
        setAllSupplier(response.data);
        setFilteredData(response.data); 
        setTotalEntries(response.data.length);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Supplier:", error);
        toast.error("Failed to fetch Supplier data");
        isError = true; 
      }
    }
  };

  // const columns = [
  //   {
  //     title: "Sr.No.",
  //     dataIndex: "",
  //     key: "index",
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     title: "Supplier Name",
  //     dataIndex: "name",
  //     key: "name",
  //   },
  //   {
  //     title: "Address",
  //     dataIndex: "address",
  //     key: "address",
  //   },
  //   {
  //     title: "City",
  //     dataIndex: "city",
  //     key: "city",
  //   },
  //   {
  //     title: "Pin Code",
  //     dataIndex: "pinCode",
  //     key: "pinCode",
  //   },
  //   {
  //     title: "State",
  //     dataIndex: "state",
  //     key: "state",
  //   },
  //   {
  //     title: "Code",
  //     dataIndex: "code",
  //     key: "code",
  //   },
  //   {
  //     title: "GSTIN",
  //     dataIndex: "gstin",
  //     key: "gstin",
  //   },
  //   {
  //     title: "Contact Person1",
  //     dataIndex: "contactPerson1",
  //     key: "contactPerson1",
  //   },
  //   {
  //     title: "Designation",
  //     dataIndex: "designation1",
  //     key: "designation1",
  //   },
  //   {
  //     title: "MobileNo",
  //     dataIndex: "mobileNo1",
  //     key: "mobileNo1",
  //   },
  //   {
  //     title: "Email Id 1",
  //     dataIndex: "emailId1",
  //     key: "emailId1",
  //   },
  //   {
  //     title: "Contact Person2",
  //     dataIndex: "contactPerson2",
  //     key: "contactPerson2",
  //   },
  //   {
  //     title: "Designation",
  //     dataIndex: "designation2",
  //     key: "designation2",
  //   },
  //   {
  //     title: "MobileNo",
  //     dataIndex: "mobileNo2",
  //     key: "mobileNo2",
  //   },
  //   {
  //     title: "Item Supplied",
  //     dataIndex: "itemSupplied",
  //     key: "itemSupplied",
  //   },
  //   {
  //     title: "Bank Name",
  //     dataIndex: "bankName",
  //     key: "bankName",
  //   },
  //   {
  //     title: "Bank Acc. No.",
  //     dataIndex: "bankAccNumber",
  //     key: "bankAccNumber",
  //   },
  //   {
  //     title: "Branch",
  //     dataIndex: "branch",
  //     key: "branch",
  //   },
  //   {
  //     title: "IFSC Code",
  //     dataIndex: "ifscCode",
  //     key: "ifscCode",
  //   },
  //   {
  //     title: "Payment Credit Period",
  //     dataIndex: "paymentCreditPeriod",
  //     key: "paymentCreditPeriod",
  //   },
  //   {
  //     title: "Pan Number",
  //     dataIndex: "panNumber",
  //     key: "panNumber",
  //   },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: (text, record) => (
  //       <div>
  //         <span
  //           type="submit"
  //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
  //           onClick={() => handleEditDataButton(record)}
  //         >
  //           <i class="fa-solid fa-pen-to-square"></i>
  //         </span>
  //         <span
  //           type="submit"
  //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
  //           onClick={() => handleDeleteData(record)} 
  //         >
  //           <i class="fa-solid fa-trash"></i>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ];

  const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Supplier Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name?.localeCompare(b.name || ''),
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    sorter: (a, b) => a.address?.localeCompare(b.address || ''),
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
    sorter: (a, b) => a.city?.localeCompare(b.city || ''),
  },
  {
    title: "Pin Code",
    dataIndex: "pinCode",
    key: "pinCode",
    sorter: (a, b) => (a.pinCode?.toString() || '').localeCompare(b.pinCode?.toString() || ''),
  },
  {
    title: "State",
    dataIndex: "state",
    key: "state",
    sorter: (a, b) => a.state?.localeCompare(b.state || ''),
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    sorter: (a, b) => (a.code?.toString() || '').localeCompare(b.code?.toString() || ''),
  },
  {
    title: "GSTIN",
    dataIndex: "gstin",
    key: "gstin",
    sorter: (a, b) => a.gstin?.localeCompare(b.gstin || ''),
  },
  {
    title: "Contact Person1",
    dataIndex: "contactPerson1",
    key: "contactPerson1",
    sorter: (a, b) => a.contactPerson1?.localeCompare(b.contactPerson1 || ''),
  },
  {
    title: "Designation",
    dataIndex: "designation1",
    key: "designation1",
    sorter: (a, b) => a.designation1?.localeCompare(b.designation1 || ''),
  },
  {
    title: "MobileNo",
    dataIndex: "mobileNo1",
    key: "mobileNo1",
     sorter: (a, b) => (a.mobileNo1?.toString() || '').localeCompare(b.mobileNo1?.toString() || ''),
  },
  {
    title: "Email Id 1",
    dataIndex: "emailId1",
    key: "emailId1",
    sorter: (a, b) => a.emailId1?.localeCompare(b.emailId1 || ''),
  },
  {
    title: "Contact Person2",
    dataIndex: "contactPerson2",
    key: "contactPerson2",
    sorter: (a, b) => a.contactPerson2?.localeCompare(b.contactPerson2 || ''),
  },
  {
    title: "Designation",
    dataIndex: "designation2",
    key: "designation2",
    sorter: (a, b) => a.designation2?.localeCompare(b.designation2 || ''),
  },
  {
    title: "MobileNo",
    dataIndex: "mobileNo2",
    key: "mobileNo2",
      sorter: (a, b) => (a.mobileNo2?.toString() || '').localeCompare(b.mobileNo2?.toString() || ''),
  },
  {
    title: "Item Supplied",
    dataIndex: "itemSupplied",
    key: "itemSupplied",
    sorter: (a, b) => (a.itemSupplied?.toString() || '').localeCompare(b.itemSupplied?.toString() || ''),
  },
  {
    title: "Bank Name",
    dataIndex: "bankName",
    key: "bankName",
    sorter: (a, b) => a.bankName?.localeCompare(b.bankName || ''),
  },
  {
    title: "Bank Acc. No.",
    dataIndex: "bankAccNumber",
    key: "bankAccNumber",
    sorter: (a, b) => (a.bankAccNumber?.toString() || '').localeCompare(b.bankAccNumber?.toString() || ''),
  },
  {
    title: "Branch",
    dataIndex: "branch",
    key: "branch",
    sorter: (a, b) => a.branch?.localeCompare(b.branch || ''),
  },
  {
    title: "IFSC Code",
    dataIndex: "ifscCode",
    key: "ifscCode",
    sorter: (a, b) => a.ifscCode?.localeCompare(b.ifscCode || ''),
  },
  {
    title: "Payment Credit Period",
    dataIndex: "paymentCreditPeriod",
    key: "paymentCreditPeriod",
    sorter: (a, b) => a.paymentCreditPeriod - b.paymentCreditPeriod,
  },
  {
    title: "Pan Number",
    dataIndex: "panNumber",
    key: "panNumber",
    sorter: (a, b) => a.panNumber?.localeCompare(b.panNumber || ''),
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#023E7D",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };


 //=========CANCEL WORKER DATA============
const handleCancel = () => {
  // setShowTable(true)
  // setShowForm(false)

  setSupplierName("");
  setAddress("");
  setCity("");
  setPinCode("");
  setState("");
  setCode("");
  setGstIn("");
  setContactPerson1("");
  setDesignation1("");
  setMobileNo1("");
  setEmailId1("");
  setContactPerson2("");
  setDesignation2("");
  setMobileNo2("");
  setItemSupplied("");
  setBankName("");
  setBankAccNumber("");
  setBranch("");
  setPaymentCreditPeriod("");
  setPanNumber("");
  setIfscCode("");

  setUpdateButton(false);
  setSaveButton(true);
  setErrors("");
};

 //=========SAVE WORKER DATA============
    const handleSubmit = async () => {
        let isValid = true;
        const errorObj = {};  
    
        if (!supplierName.trim()) {
          isValid = false;
          errorObj.supplierName = "Supplier Name is required *";
        }
        if (!address) {
          isValid = false;
          errorObj.address = "Address is required *";
        }
        if (!city) {
          isValid = false;
          errorObj.city = "City is required *";
        }
        if (!pinCode) {
          isValid = false;
          errorObj.pinCode = "Pin Code is required *";
        }
        if (!state) {
          isValid = false;
          errorObj.state = "State is required *";
        }
        if (!code) {
          isValid = false;
          errorObj.code = "Code is required *";
        }
        if (!gstIn) {
          isValid = false;
          errorObj.gstIn = "GSTIN is required *";
        }
        // if (!contactPerson1.trim()) {
        //   isValid = false;
        //   errorObj.contactPerson1 = "Contact Person is required *";
        // }
        // if (!designation1.trim()) {
        //   isValid = false;
        //   errorObj.designation1 = "Designation is required *";
        // }
        // if (!mobileNo1.trim()) {
        //   isValid = false;
        //   errorObj.mobileNo1 = "Mobile No. is required *";
        // }
        // if (!emailId1.trim()) {
        //   isValid = false;
        //   errorObj.emailId1 = "Email Id is required *";
        // }
        // if (!contactPerson2.trim()) {
        //   isValid = false;
        //   errorObj.contactPerson2 = "Contact Person is required *";
        // }
        // if (!designation2.trim()) {
        //   isValid = false;
        //   errorObj.designation2 = "Designation is required *";
        // }
        // if (!mobileNo2.trim()) {
        //   isValid = false;
        //   errorObj.mobileNo2 = "Mobile No. is required *";
        // }       
        // if (!itemSupplied.trim()) {
        //   isValid = false;
        //   errorObj.itemSupplied = "Item Supplied is required *";
        // }
        // if (!bankName.trim()) {
        //   isValid = false;
        //   errorObj.bankName = "Bank Name is required *";
        // }
        // if (!bankAccNumber.trim()) {
        //   isValid = false;
        //   errorObj.bankAccNumber = "Bank Acc No. is required *";
        // }
        // if (!branch.trim()) {
        //   isValid = false;
        //   errorObj.branch = "Branch is required *";
        // }
        // if (!ifscCode.trim()) {
        //   isValid = false;
        //   errorObj.ifscCode = "IFSC Code is required *";
        // }
        // if (!paymentCreditPeriod.trim()) {
        //   isValid = false;
        //   errorObj.paymentCreditPeriod = "Payment Credit Period is required *";
        // }
        // if (!panNumber.trim()) {
        //   isValid = false;
        //   errorObj.panNumber = "Pan Number is required *";
        // }
       
    
        setErrors(errorObj); // Set error messages
    
        if (!isValid) return;
    
        const saveData = {
            name: supplierName,
            address: address,
            city: city,
            pinCode: parseFloat(pinCode),
            state: state,
            code: parseFloat(code),
            gstin: gstIn,
            contactPerson1: contactPerson1,
            designation1: designation1,
            mobileNo1: parseInt(mobileNo1),
            emailId1: emailId1,
            contactPerson2: contactPerson2,
            designation2: designation2,
            mobileNo2: parseInt(mobileNo2),
            itemSupplied: parseFloat(itemSupplied),
            bankName: bankName,
            bankAccNumber: parseInt(bankAccNumber),
            branch: branch,
            ifscCode: ifscCode,
            paymentCreditPeriod: parseFloat(paymentCreditPeriod),
            panNumber: panNumber,
          };       
        
    
        try {
          const response = await axios.post(SaveSupplierMaster, saveData,commonHeaders);
    
          if (response.data === "CREATED") {
            toast.success("Supplier Added successfully!");
            fetchSupplier();
            handleCancel();
          }
          else if (response.data === "ALREADYEXISTED") {
            toast.warn("Supplier Already exist!");
          }
        } catch (error) {
          console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
        }
    };

//=========EDIT WORKER DATA============
const handleEditDataButton = (item) => {
  setUpdateButton(true);
  setSaveButton(false);

  setSupplierId(item.id);
  setSupplierName(item.name);
  setAddress(item.address);
  setCity(item.city);
  setPinCode(item.pinCode);
  setState(item.state);
  setCode(item.code);
  setGstIn(item.gstin);
  setContactPerson1(item.contactPerson1);
  setDesignation1(item.designation1);
  setMobileNo1(item.mobileNo1);
  setEmailId1(item.emailId1);
  setContactPerson2(item.contactPerson2);
  setDesignation2(item.designation2);
  setMobileNo2(item.mobileNo2);
  setItemSupplied(item.itemSupplied);
  setBankName(item.bankName);
  setBankAccNumber(item.bankAccNumber);
  setBranch(item.branch);
  setIfscCode(item.ifscCode);
  setPaymentCreditPeriod(item.paymentCreditPeriod);
  setPanNumber(item.panNumber);
};

 //=========UPDATE WORKER DATA============
const handleUpdate = async () => {
  if (
    !supplierName || !address ||  !city || !pinCode || !state || !code || !gstIn ) {
    toast.warn("Please fill all fields!");
    return;
  }

  const updateData = {
    id: supplierId,
    name: supplierName,
    address: address,
    city: city,
    pinCode: parseInt(pinCode),
    state: state,
    code: parseFloat(code),
    gstin: gstIn,
    contactPerson1: contactPerson1,
    designation1: designation1,
    mobileNo1: parseInt(mobileNo1),
    emailId1: emailId1,
    contactPerson2: contactPerson2,
    designation2: designation2,
    mobileNo2: parseInt(mobileNo2),
    itemSupplied: parseFloat(itemSupplied),
    bankName: bankName,
    bankAccNumber: parseInt(bankAccNumber),
    branch: branch,
    ifscCode: ifscCode,
    paymentCreditPeriod: parseFloat(paymentCreditPeriod),
    panNumber: panNumber,
  };


  try {
    const response = await axios.put(UpdateSupplierMaster, updateData,commonHeaders);

    if (response.data === "UPDATED") {
      toast.success("Supplier Updated successfully!");
      fetchSupplier();
      handleCancel();
    }
    else if (response.data === "ALREADYEXISTED") {
      toast.warn("Supplier Already exist!");
    }
  } catch (error) {
    console.error("Error during API call:", error);
    toast.error("Error occurred while updating data");
  }
};

 //=========DELETE WORKER DATA============
const handleDeleteData = async (item) => {
  const confirmDelete = window.confirm(
    `Are you sure you want to delete the Supplier "${item.name}"?`
  );
  if (!confirmDelete) return;

  try {
    const response = await axios.delete(`${DeleteSupplierMaster}?id=${item.id}`,commonHeaders1);
    if (response.data === "DELETED") {
      toast.success("Supplier deleted successfully!");
      fetchSupplier();
      handleCancel();
    }
    else if (response.data === "NOTFOUND") {
      toast.warn("Supplier data notfound!");
    }
  } catch (error) {
    console.error("Error during delete operation:", error);
    toast.error("Error occurred while deleting the Supplier");
  }
};

  return (
    <>
      <div className="px-5 py-3">
        <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          <div className="col-12">
    
              <>
              <div className="row px-md-5 mt-3 p-2" >
                    <div className="col-md-1"></div>
                    <div className="col-md-10">
                        <div className="row p-0 m-0">

                          <div className="col-lg-8 py-1">
                                <label className="labels">Name</label>
                                <Input maxLength={250}
                                  value={supplierName}
                                  onChange={(e) => setSupplierName(e.target.value)}
                                  placeholder="Enter Name"
                                />
                                {errors.supplierName && (
                                  <div className="errorField">{errors.supplierName}</div>
                                )}
                          </div>

                          <div className="col-lg-4 py-1">
                                <label className="labels">GSTIN</label>
                                <Input
                                  value={gstIn} maxLength={250}
                                  onChange={(e) => setGstIn(e.target.value)}
                                  placeholder="Enter Code"
                                />
                                {errors.gstIn && (
                                  <div className="errorField">{errors.gstIn}</div>
                                )}
                          </div>

                          <div className="col-lg-10 py-1">
                              <label className="labels">Address</label>
                              <Input.TextArea
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Enter Address"
                                maxLength={250}
                              />
                              {errors.address && <div className="errorField">{errors.address}</div>}
                          </div> 
                          <div className="col-lg-2"></div>

                          <div className="col-lg-4 py-1">
                                <label className="labels">City</label>
                                <Input
                                  value={city} maxLength={250}
                                  onChange={(e) => setCity(e.target.value)}
                                  placeholder="Enter Name"
                                />
                                {errors.city && (
                                  <div className="errorField">{errors.city}</div>
                                )}
                          </div>

                          <div className="col-lg-2 py-1">
                                <label className="labels">Pin Code</label>
                                <Input
                                  value={pinCode} maxLength={6}
                                  onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d{0,10}$/.test(value)) setPinCode(value); // only allow up to 10 digits
                                    }}
                                  placeholder="Enter Code"
                                />
                                {errors.pinCode && (
                                  <div className="errorField">{errors.pinCode}</div>
                                )}
                          </div>
                          
                          <div className="col-lg-4 py-1">
                                <label className="labels">State</label>
                                <Input
                                  value={state} maxLength={250}
                                  onChange={(e) => setState(e.target.value)}
                                  placeholder="Enter State"
                                />
                                {errors.state && (
                                  <div className="errorField">{errors.state}</div>
                                )}
                          </div>

                          <div className="col-lg-2 py-1">
                                <label className="labels">Code</label>
                                <Input
                                  value={code} 
                                  onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d{0,10}$/.test(value)) setCode(value); // only allow up to 10 digits
                                    }}
                                  placeholder="Enter Code"
                                />
                                {errors.code && (
                                  <div className="errorField">{errors.code}</div>
                                )}
                          </div>

                        <div className="col-lg-5 py-1">
                                <label className="labels">Contact Person 1</label>
                                <Input
                                  value={contactPerson1} maxLength={250}
                                  onChange={(e) => setContactPerson1(e.target.value)}
                                  placeholder="Enter Code"
                                />
                                {/* {errors.contactPerson1 && (
                                  <div className="errorField">{errors.contactPerson1}</div>
                                )} */}
                          </div>

                          <div className="col-lg-4 py-1">
                                <label className="labels">Designation 1</label>
                                <Input
                                  value={designation1} maxLength={250}
                                  onChange={(e) => setDesignation1(e.target.value)}
                                  placeholder="Enter Code"
                                />
                                {/* {errors.designation1 && (
                                  <div className="errorField">{errors.designation1}</div>
                                )} */}
                          </div>

                          <div className="col-lg-3 py-1">
                                <label className="labels">Mobile No.1</label>
                                <Input
                                    value={mobileNo1}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d{0,10}$/.test(value)) setMobileNo1(value); // only allow up to 10 digits
                                    }}
                                    placeholder="Enter Mobile Number"
                                    maxLength={10}
                                  />
                                  {/* {errors.mobileNo1 && (
                                    <div className="errorField">{errors.mobileNo1}</div>
                                  )} */}
                          </div>

                          <div className="col-lg-5 py-1">
                            <label className="labels">Email ID</label>
                            <Input
                              value={emailId1}
                              onChange={(e) => {
                                const value = e.target.value;
                                setEmailId1(value);

                                // Basic email format validation
                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                if (value && !emailRegex.test(value)) {
                                  setErrors((prev) => ({ ...prev, emailId1: "Invalid email format" }));
                                } else {
                                  setErrors((prev) => ({ ...prev, emailId1: "" }));
                                }
                              }}
                              placeholder="Enter Email ID"
                            />
                            {/* {errors.emailId1 && (
                              <div className="errorField">{errors.emailId1}</div>
                            )} */}
                          </div>
                          <div className="col-lg-7 py-1"></div>

                          <div className="col-lg-5 py-1">
                                <label className="labels">Contact Person 2</label>
                                <Input
                                  value={contactPerson2} maxLength={250}
                                  onChange={(e) => setContactPerson2(e.target.value)}
                                  placeholder="Enter Code"
                                />
                                {/* {errors.contactPerson2 && (
                                  <div className="errorField">{errors.contactPerson2}</div>
                                )} */}
                          </div>

                          <div className="col-lg-4 py-1">
                                <label className="labels">Designation 2</label>
                                <Input
                                  value={designation2} maxLength={250}
                                  onChange={(e) => setDesignation2(e.target.value)}
                                  placeholder="Enter Code"
                                />
                                {/* {errors.designation2 && (
                                  <div className="errorField">{errors.designation2}</div>
                                )} */}
                          </div>

                          <div className="col-lg-3 py-1">
                                <label className="labels">Mobile No.2</label>
                                <Input
                                    value={mobileNo2}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d{0,10}$/.test(value)) setMobileNo2(value); // only allow up to 10 digits
                                    }}
                                    placeholder="Enter Mobile Number"
                                    maxLength={10}
                                  />
                                  {/* {errors.mobileNo2 && (
                                    <div className="errorField">{errors.mobileNo2}</div>
                                  )} */}
                          </div>

                          <div className="col-lg-4 py-1">
                                <label className="labels">Item Supplied</label>
                                <Input type="number"
                                  value={itemSupplied} maxLength={250}
                                  onChange={(e) => setItemSupplied(e.target.value)}
                                  placeholder="Enter Item Supplied"
                                />
                                {/* {errors.itemSupplied && (
                                  <div className="errorField">{errors.itemSupplied}</div>
                                )} */}
                          </div> 
                          <div className="col-lg-8 py-1"></div>

                          <div className="col-lg-4 py-1">
                                <label className="labels">Bank Name</label>
                                <Input
                                  value={bankName} maxLength={250}
                                  onChange={(e) => setBankName(e.target.value)}
                                  placeholder="Enter Bank Name"
                                />
                                {/* {errors.bankName && (
                                  <div className="errorField">{errors.bankName}</div>
                                )} */}
                          </div>    

                          <div className="col-lg-4 py-1">
                                <label className="labels">Bank Acc. No.</label>
                                <Input type="tel"
                                  value={bankAccNumber}
                                  onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d{0,15}$/.test(value)) setBankAccNumber(value); // only allow up to 10 digits
                                    }}
                                  placeholder="Enter Bank Acc. No."
                                />
                                {/* {errors.bankAccNumber && (
                                  <div className="errorField">{errors.bankAccNumber}</div>
                                )} */}
                          </div>  

                          <div className="col-lg-4 py-1">
                                <label className="labels">Branch</label>
                                <Input 
                                  value={branch} maxLength={250}
                                  onChange={(e) => setBranch(e.target.value)}
                                  placeholder="Enter Branch"
                                />
                                {/* {errors.branch && (
                                  <div className="errorField">{errors.branch}</div>
                                )} */}
                          </div>  

                          <div className="col-lg-4 py-1">
                                <label className="labels">IFSC Code</label>
                                <Input
                                  value={ifscCode} maxLength={250}
                                  onChange={(e) => setIfscCode(e.target.value)}
                                  placeholder="Enter IFSC Code"
                                />
                                {/* {errors.ifscCode && (
                                  <div className="errorField">{errors.ifscCode}</div>
                                )} */}
                          </div>     

                          <div className="col-lg-4 py-1">
                                <label className="labels">Payment Credit Period</label>
                                <Input type="number"
                                  value={paymentCreditPeriod} maxLength={250}
                                  onChange={(e) => setPaymentCreditPeriod(e.target.value)}
                                  placeholder="Enter Period"
                                />
                                {/* {errors.paymentCreditPeriod && (
                                  <div className="errorField">{errors.paymentCreditPeriod}</div>
                                )} */}
                          </div> 

                            <div className="col-lg-4 py-1">
                                <label className="labels">Pan Number</label>
                                <Input
                                  value={panNumber} maxLength={10}
                                  onChange={(e) => setPanNumber(e.target.value)}
                                  placeholder="Enter Number"
                                />
                                {/* {errors.panNumber && (
                                  <div className="errorField">{errors.panNumber}</div>
                                )} */}
                          </div>                   

                        </div> 
                    </div> 
                    <div className="col-md-1"></div>

                      <div className="col-12 text-center pt-3">
                        <Button
                          type="submit"
                          className="CancelBtn mx-1"
                          onClick={handleCancel}
                        >
                          Cancel
                        </Button>
                        {saveButton && (
                        <Button
                          type="submit"
                          className="SubmitBtn mx-1"
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                        )}
                        {updateButton && (
                          <Button
                            type="submit"
                            className="UpdateBtn mx-1"
                            onClick={handleUpdate}
                          >
                            Update
                          </Button>
                        )}
                      </div>

                <div  className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid rgb(207, 207, 207)" }}></div>
              </div>
              </>
     
            {/*================ Table =========================*/}
        
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: "white" }}
              >

                  {/* <div className="row ps-2 m-0 mb-2">
                    <div className="col-12 col-md-3 col-lg-1">
                      <Button
                        onClick={handleShowForm}
                        style={{ backgroundColor: '#f8bf28' }}
                      >
                        Add New +
                      </Button>
                    </div>
                    <div className="col-12 col-md-9 col-lg-11"></div>
                  </div> */}

                <div
                  className="col-12 px-md-5"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: "center" }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: "white" }}>
                  <Table
                    bordered
                    style={{ padding: "0px 20px", overflowX: "auto" }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </div>
   </>
  )
}

export default SupplierMaster